// Borrowed largely from Optimizely ContentSquare integration docs
// https://www.optimizely.com/sv/utvecklare/labs/contentsquare-integration-full-stack/

export const onDecision = (decisionObject) => {
  function callback(context) {
    if (!disableCallback) {
      disableCallback = true;
      if (window.CS_CONF) {
        window.CS_CONF.integrations = window.CS_CONF.integrations || [];
        window.CS_CONF.integrations.push("Optimizely Full Stack");
      }
    }
  }

  var disableCallback = false;

  var csPrefix = "AB_OP_",
    csKey,
    csValue;
  csKey = csPrefix + decisionObject.experiment.key;
  csValue = decisionObject.variation.key;

  window._uxa = window._uxa || [];
  window._uxa.push(["afterPageView", callback]);
  window._uxa.push(["trackDynamicVariable", { key: csKey, value: csValue }]);
};
